<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00080.controle.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 0,
          label: 'P00080.card.state.off' | translate,
          icon: 'fa-kit fa-picto-off',
          color: 'color-danger',
        },
        {
          ref: 1,
          label: 'P00080.card.state.regul' | translate,
          icon: 'fa-kit fa-picto-programme',
          color: 'color-green',
        },
      ]"
      [value]="this.actionStack!.getValue('alCEtatProduit')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Altimeo_Control,
          'alCEtatProduit',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>
